<template>
  <div class="form-group mb-0">
    <div :class="hasIcon(icon) || hasCustomSlot">
      <!-- Left icon -->
      <span v-if="iconDir === 'left'" class="input-group-text">
        <slot name="icon">
          <i :class="getIcon(icon)" v-if="icon"></i>
        </slot>
      </span>

      <!-- Input -->
     <input
      :id="id"
      :type="type"
      class="form-control input-border mb-0"
      :class="[getClasses(size, success, error), $attrs.class]"
      :name="name"
      :value="modelValue"
      :placeholder="placeholder"
      :isRequired="isRequired"
      :disabled="disabled"
      v-bind="$attrs"
      @input="emit('update:modelValue', $event.target.value)"
    />

      <!-- Right icon -->
      <span v-if="iconDir === 'right'" class="input-group-text">
        <slot name="icon">
          <i :class="getIcon(icon)" v-if="icon"></i>
        </slot>
      </span>
    </div>
  </div>
</template>

<script setup>
import { useSlots } from 'vue';
defineOptions({ inheritAttrs: false });

const slots = useSlots();
const hasCustomSlot = slots.icon ? 'input-group' : null;

const emit = defineEmits(["update:modelValue"]);

defineProps({
   disabled: {
    type: Boolean,
    default: false,
  },
  readonly: { type: Boolean, default: false },
  size: { type: String, default: "default" },
  success: { type: Boolean, default: false },
  error: { type: Boolean, default: false },
  icon: { type: String, default: "" },
  iconDir: { type: String, default: "" },
  name: { type: String, default: "" },
  id: { type: String, default: "" },
  modelValue: { type: String, default: "" },
  placeholder: { type: String, default: "" },
  type: { type: String, default: "text" },
  isRequired: { type: Boolean, default: false },
});

const getClasses = (size, success, error) => {
  let sizeValue = size ? `form-control-${size}` : null;
  let isValidValue = error ? "is-invalid" : success ? "is-valid" : "";
  return `${sizeValue} ${isValidValue}`;
};

const getIcon = (icon) => (icon ? icon : null);
const hasIcon = (icon) => (icon ? "input-group" : null);
</script>

<style scoped>
.is-invalid {
  border: 1px solid #dc3545 !important;
  box-shadow: 0 0 0 0.1rem rgba(220, 53, 69, 0.25);
}

.is-valid {
  border: 1px solid #28a745;
  box-shadow: 0 0 0 0.1rem rgba(40, 167, 69, 0.25);
}

input[disabled] {
  background-color: #ffffff; /* สีเทาอ่อนสำหรับ disabled */
  cursor: not-allowed;
}

input[readonly] {
  background-color: #ffffff; /* สีเทาอ่อนกว่า disabled */
}

</style>
